import api from './api';

/**
 * 시스템 설정 API
 * - 공개 설정 조회: 인증 불필요 (프론트엔드 초기화 시 사용)
 * - 설정 변경: 관리자 인증 필요
 */
const settingsApi = {
  /**
   * 공개 시스템 설정 조회 (인증 불필요)
   * 반환 예시: { browser_language_detection: true }
   */
  getPublicSettings: async () => {
    const response = await api.get('/settings/public');
    return response.data;
  },

  /**
   * 전체 시스템 설정 조회 (관리자 인증 필요)
   * description, updated_at 포함하여 반환
   */
  getAllSettings: async () => {
    const token = localStorage.getItem('adminToken');
    const response = await api.get('/settings/', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  /**
   * 설정 값 업데이트 (관리자 인증 필요)
   * @param {string} key - 설정 키
   * @param {string} value - 설정 값 ('true' | 'false' | 기타 문자열)
   */
  updateSetting: async (key, value) => {
    const token = localStorage.getItem('adminToken');
    const response = await api.put(
      `/settings/${key}`,
      { value: String(value) },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
};

export default settingsApi;
